import {
  getBreakpointName,
  useBreakpoint,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';
import {Text} from 'react-native';
import styled from 'styled-components/native';

const StyledBreakpoints = styled.View`
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
`;

const BreakpointDebug: React.FunctionComponent = () => {
  const breakpoint = useBreakpoint();
  const breakpointName = getBreakpointName(breakpoint);

  return (
    <StyledBreakpoints>
      <Text>{breakpointName}</Text>
    </StyledBreakpoints>
  );
};

export default BreakpointDebug;
